export default __webpack_public_path__ + "static/media/board-bg-sm.291a41df.png";